import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Guards routes that require a signed-in user.
 * - Waits for the auth session to finish restoring (otherwise a direct visit or
 *   hard refresh bounces to /login before the token is read).
 * - Works both as a layout route (`<Route element={<PrivateRoute/>}>` → <Outlet/>)
 *   and as a wrapper (`<PrivateRoute><Page/></PrivateRoute>` → children).
 */
const PrivateRoute = ({ children }) => {
  const { isLoggedIn, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children ? children : <Outlet />;
};

export default PrivateRoute;
